import React, { useState } from 'react';
import { FiSearch, FiFilter, FiDownload, FiEye, FiMoreHorizontal, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { motion } from 'framer-motion';

const ordersData = [
  { id: '#ORD-7721', customer: 'Alex Johnson', product: 'Premium Latte', amount: '$45.00', status: 'Delivered', branch: 'Downtown', date: '2023-10-24' },
  { id: '#ORD-7722', customer: 'Maria Garcia', product: 'Breakfast Combo', amount: '$120.50', status: 'Pending', branch: 'Westside', date: '2023-10-24' },
  { id: '#ORD-7723', customer: 'James Wilson', product: 'Bulk Coffee Beans', amount: '$540.00', status: 'Shipped', branch: 'Warehouse', date: '2023-10-23' },
  { id: '#ORD-7724', customer: 'Sarah Miller', product: 'Croissant Box', amount: '$32.00', status: 'Cancelled', branch: 'Downtown', date: '2023-10-23' },
  { id: '#ORD-7725', customer: 'Robert Brown', product: 'Iced Tea Pack', amount: '$85.00', status: 'Delivered', branch: 'Northside', date: '2023-10-22' },
];

const Orders = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const getStatusColor = (status) => {
    switch (status) {
      case 'Delivered': return 'success';
      case 'Pending': return 'warning';
      case 'Shipped': return 'info';
      case 'Cancelled': return 'danger';
      default: return 'secondary';
    }
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="container-fluid p-0"
    >
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="fw-bold mb-1">Order Management</h2>
          <p className="text-muted small mb-0">Track and manage all franchise orders in real-time.</p>
        </div>
        <div className="d-flex gap-2">
          <button className="btn glass-card border-0 text-white px-3 d-flex align-items-center gap-2">
            <FiDownload /> Export CSV
          </button>
          <button className="btn btn-primary px-3">Create New Order</button>
        </div>
      </div>

      <div className="glass-card p-4">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
          <div className="d-flex gap-2 flex-grow-1" style={{ maxWidth: '400px' }}>
            <div className="input-group">
              <span className="input-group-text bg-transparent border-end-0 text-muted"><FiSearch /></span>
              <input 
                type="text" 
                className="form-control border-start-0 ps-0" 
                placeholder="Search by Order ID or Customer..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="d-flex gap-2">
            <button className="btn glass-card border-0 text-white d-flex align-items-center gap-2">
              <FiFilter /> Filters
            </button>
            <select className="form-select glass-card border-0 text-white" style={{ width: '150px' }}>
              <option>Last 7 Days</option>
              <option>Last 30 Days</option>
              <option>This Month</option>
              <option>Custom Range</option>
            </select>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-dark table-hover mb-0 border-0">
            <thead>
              <tr className="text-muted small uppercase">
                <th className="border-0 py-3">Order ID</th>
                <th className="border-0 py-3">Customer</th>
                <th className="border-0 py-3">Product</th>
                <th className="border-0 py-3">Branch</th>
                <th className="border-0 py-3">Amount</th>
                <th className="border-0 py-3">Date</th>
                <th className="border-0 py-3">Status</th>
                <th className="border-0 py-3 text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {ordersData.map((order) => (
                <tr key={order.id} className="align-middle">
                  <td className="border-0 py-4 fw-bold">{order.id}</td>
                  <td className="border-0 py-4">
                    <div className="d-flex align-items-center gap-2">
                      <div className="rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center fw-bold text-primary small" style={{ width: '32px', height: '32px' }}>
                        {order.customer.charAt(0)}
                      </div>
                      <span className="small">{order.customer}</span>
                    </div>
                  </td>
                  <td className="border-0 py-4 small">{order.product}</td>
                  <td className="border-0 py-4">
                    <span className="badge bg-secondary bg-opacity-10 text-muted border border-secondary border-opacity-20 small">
                      {order.branch}
                    </span>
                  </td>
                  <td className="border-0 py-4 fw-bold text-primary">{order.amount}</td>
                  <td className="border-0 py-4 text-muted small">{order.date}</td>
                  <td className="border-0 py-4">
                    <span className={`badge bg-${getStatusColor(order.status)} bg-opacity-10 text-${getStatusColor(order.status)} border border-${getStatusColor(order.status)} border-opacity-20`}>
                      {order.status}
                    </span>
                  </td>
                  <td className="border-0 py-4 text-end">
                    <div className="d-flex justify-content-end gap-2">
                      <button className="btn btn-sm glass-card border-0 text-white"><FiEye /></button>
                      <button className="btn btn-sm glass-card border-0 text-white"><FiMoreHorizontal /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-4 pt-4 border-top border-opacity-10">
          <p className="text-muted small mb-0">Showing 1 to 5 of 120 orders</p>
          <div className="d-flex gap-2">
            <button className="btn btn-sm glass-card border-0 text-white"><FiChevronLeft /></button>
            <button className="btn btn-sm btn-primary px-3">1</button>
            <button className="btn btn-sm glass-card border-0 text-white">2</button>
            <button className="btn btn-sm glass-card border-0 text-white">3</button>
            <button className="btn btn-sm glass-card border-0 text-white"><FiChevronRight /></button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Orders;
